import { Uuid } from "#customTypes/globalTypes"
import { DatabaseObject, IsoDate } from "#customTypes/types"

export enum NOTIFICATION_TYPE {
  EVALUATION = "EVALUATION",
  CHANGELOG = "CHANGELOG",
  PORTFOLIO = "PORTFOLIO",
  STANDOUT = "STANDOUT",
}

export enum NOTIFICATION_SUBTYPE {
  EVAL_COMMENT = "EVAL_COMMENT",
  EVAL_SUBMITTED = "EVAL_SUBMITTED",
  EVAL_APPROVED = "EVAL_APPROVED",
  EVAL_REJECTED = "EVAL_REJECTED",
  EVAL_PRINTED = "EVAL_PRINTED",
  EVAL_ASSIGNED = "EVAL_ASSIGNED",
  CHANGELOG_NEW = "CHANGELOG_NEW",
  PORTFOLIO_UPDATED = "PORTFOLIO_UPDATED",
  STANDOUT_LIKED = "STANDOUT_LIKED",
}

export enum NOTIFICATION_PRIORITY {
  LOW = "LOW",
  NORMAL = "NORMAL",
  HIGH = "HIGH",
  URGENT = "URGENT",
}

export interface NotificationConstructor extends DatabaseObject {
  id: Uuid
  recipientId: Uuid
  type: NOTIFICATION_TYPE
  subtype?: NOTIFICATION_SUBTYPE
  priority: NOTIFICATION_PRIORITY
  header: string
  message: string
  read: boolean
  readAt?: IsoDate
  archived: boolean
  archivedAt?: IsoDate
  metadata?: Record<string, unknown>
}
